var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "upload-modular" }, [_c('el-upload', { ref: "uploader", class: { hide: _vm.hideUpload }, attrs: { "with-credentials": "", "list-type": _vm.uploadConfig.listType, "accept": _vm.accept, "data": _vm.uploadConfig.paramsData, "action": _vm.uploadFileUrl, "file-list": _vm.uploadList, "on-remove": _vm.handleUploadRemove, "on-change": _vm.handleUploadChange, "on-success": _vm.handleUploadSuccess, "on-error": _vm.handleUploadError } }, [_c('i', { class: _vm.uploadIcon })])], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };